import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../i18n-context";
import { LOGO_HORIZONTAL } from "../assets";

export default function Footer() {
  const { t } = useI18n();
  return (
    <footer className="bg-brand-ink text-white pt-20 pb-8 relative overflow-hidden">
      <div className="absolute inset-0 bg-grid-dark opacity-30 pointer-events-none" />
      <div className="container relative">
        <div className="grid md:grid-cols-4 gap-12 mb-16">
          <div className="md:col-span-2">
            <img src={LOGO_HORIZONTAL} alt="Akwaan Express" className="h-20 md:h-24 mb-6 -ms-2" />
            <p className="text-base md:text-lg text-white/70 max-w-md mb-6">{t.footer.tag}</p>
            <div className="flex items-center gap-2 text-sm md:text-base font-mono uppercase tracking-wider text-brand-orange">
              <span className="h-2 w-2 rounded-full bg-brand-orange animate-pulse" />
              {t.hero.kicker}
            </div>
          </div>

          <div>
            <div className="text-sm md:text-base uppercase tracking-wider font-mono font-bold text-brand-orange mb-4">
              {t.footer.sections.company}
            </div>
            <ul className="space-y-3 text-base text-white/75">
              <li><Link to="/about" className="hover:text-brand-orange">{t.nav.about}</Link></li>
              <li><Link to="/services" className="hover:text-brand-orange">{t.nav.services}</Link></li>
              <li><Link to="/apps" className="hover:text-brand-orange">{t.nav.apps}</Link></li>
              <li><Link to="/partners" className="hover:text-brand-orange">{t.nav.partners}</Link></li>
              <li><Link to="/faq" className="hover:text-brand-orange">{t.nav.faq}</Link></li>
              <li><Link to="/contact" className="hover:text-brand-orange">{t.nav.contact}</Link></li>
            </ul>
          </div>

          <div>
            <div className="text-sm md:text-base uppercase tracking-wider font-mono font-bold text-brand-orange mb-4">
              {t.footer.sections.contact}
            </div>
            <ul className="space-y-3 text-base text-white/75">
              <li><a href="mailto:info@akwaan.express" className="hover:text-brand-orange">info@akwaan.express</a></li>
              <li><a href="mailto:sales@akwaan.com" className="hover:text-brand-orange">sales@akwaan.com</a></li>
              <li><a href="mailto:operation@akwaan.com" className="hover:text-brand-orange">operation@akwaan.com</a></li>
              <li className="text-white/75"><span dir="ltr">+964 788 588 4088</span></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-wrap items-center justify-between gap-4 text-sm text-white/50">
          <div>© {new Date().getFullYear()} — {t.footer.rights}</div>
          <div className="font-mono text-xs uppercase tracking-wider">akwaan.com</div>
        </div>
      </div>
    </footer>
  );
}
